/**
 * Les mesures du panneau de Sam (`<SamSheet>`) que l'écran qui le porte lit pour lui faire de la
 * place. Pures : elles se lisent sous Jest.
 */

/** À partir de cette largeur, l'activité et la conversation tiennent côte à côte. */
export const SAM_PANEL_FROM = 900
/** Deux tours de parole s'y lisent sans que l'activité à côté devienne illisible. */
export const SAM_PANEL_WIDTH = 420
